<template>
  <div class="bg-white border border-slate-200 rounded-2xl p-6 md:p-8 shadow-sm">
    <!-- 步骤标签 -->
    <div class="flex items-center gap-2 mb-5">
      <span class="px-2.5 py-1 bg-[#F2C94C]/10 text-[#F2C94C] text-xs font-bold rounded-lg">步骤 1 / 3</span>
      <span class="text-sm font-bold text-slate-900">描述场景</span>
      <span class="text-xs text-slate-400">输入你的管理困境，或从下方快速选择</span>
    </div>

    <!-- 搜索输入区 -->
    <div class="space-y-3 mb-8">
      <div class="relative flex items-center rounded-2xl bg-white border border-slate-200 focus-within:border-[#F2C94C]/50 shadow-sm transition-all">
        <div class="pl-4 pr-2 text-slate-400">
          <IconSearch class-name="w-5 h-5" />
        </div>
        <input
          type="text"
          v-model="inputValue"
          @keydown.enter="handleEnter"
          placeholder="描述你的管理困境..."
          class="w-full py-5 bg-transparent outline-none text-slate-700 placeholder-slate-300"
        />
      </div>

      <button
        @click="onNext"
        :disabled="!canGoNext"
        :class="[
          'w-full py-4 font-black text-lg rounded-xl shadow-md transition-all active:scale-[0.98] flex items-center justify-center gap-2',
          canGoNext
            ? 'bg-[#F2C94C] hover:bg-[#E5B73B] text-white'
            : 'bg-slate-100 text-slate-400 cursor-not-allowed'
        ]"
      >
        下一步：回答调研题目
        <IconArrowRight class-name="w-5 h-5" />
      </button>
    </div>

    <!-- 常见困境 -->
    <div>
      <div class="flex items-center gap-3 mb-4">
        <div class="w-1 h-5 bg-[#F2C94C] rounded-full"></div>
        <h3 class="text-sm font-bold text-slate-800">常见困境（点击快速选择）</h3>
      </div>
      <div class="grid grid-cols-1 md:grid-cols-2 gap-3">
        <div
          v-for="(item, i) in COMMON_PROBLEMS"
          :key="item.id"
          :style="{ animationDelay: i * 0.05 + 's' }"
          class="animate-slide-up"
          @click="handleCardClick(item.desc)"
          :class="[
            'p-4 bg-slate-50 border rounded-xl hover:border-[#F2C94C] hover:shadow-md hover:shadow-[#F2C94C]/5 transition-all cursor-pointer group',
            scenario === item.desc ? 'border-[#F2C94C] bg-[#F2C94C]/5' : 'border-slate-200'
          ]"
        >
          <h4 :class="[
            'text-sm font-bold mb-1 transition-colors',
            scenario === item.desc ? 'text-[#F2C94C]' : 'text-slate-800 group-hover:text-[#F2C94C]'
          ]">{{ item.title }}</h4>
          <p class="text-xs text-slate-500 leading-relaxed line-clamp-2">{{ item.desc }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { COMMON_PROBLEMS } from '../../../constants/scenarios';
import IconSearch from '../../icons/IconSearch.vue';
import IconArrowRight from '../../icons/IconArrowRight.vue';

export default {
  name: 'StepScenario',
  components: {
    IconSearch,
    IconArrowRight
  },
  props: {
    scenario: {
      type: String,
      default: ''
    },
    canGoNext: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputValue: this.scenario,
      COMMON_PROBLEMS
    };
  },
  watch: {
    scenario(newVal) {
      this.inputValue = newVal;
    },
    inputValue(newVal) {
      this.$emit('scenario-change', newVal);
    }
  },
  methods: {
    handleCardClick(desc) {
      this.inputValue = desc;
      this.$emit('scenario-change', desc);
    },
    handleEnter() {
      if (this.canGoNext) {
        this.onNext();
      }
    },
    onNext() {
      this.$emit('next');
    }
  }
};
</script>
